export default function ($translateProvider) {
  'ngInject';

  $translateProvider.translations('en', require('./locales/translation.en.json'));

  $translateProvider.preferredLanguage('en');
}
